import React            from 'react';

class Placeholder extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render(){
        let p = this.props;
        return(
            <div 
                className   ={ `simprakit-dropdown-wrapper` }
                onClick     = { e => p.onClick(e) }
                ref         = "DROPDOWN_WRAPPER_INPUT"
            >
                { p.children }
            </div>
        )
    }
}

export default Placeholder;